export default function PencilIcon({ ...rest }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...rest}
    >
      <path
        d='M10.9457 4.10852H3.98794C3.46071 4.10852 2.95507 4.31796 2.58225 4.69077C2.20944 5.06359 2 5.56923 2 6.09646V20.012C2 20.5393 2.20944 21.0449 2.58225 21.4177C2.95507 21.7905 3.46071 22 3.98794 22H17.9035C18.4308 22 18.9364 21.7905 19.3092 21.4177C19.682 21.0449 19.8915 20.5393 19.8915 20.012V13.0543'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.4005 2.61757C18.7959 2.22215 19.3322 2 19.8915 2C20.4507 2 20.987 2.22215 21.3824 2.61757C21.7778 3.013 22 3.54931 22 4.10853C22 4.66775 21.7778 5.20406 21.3824 5.59949L11.9397 15.0422L7.96381 16.0362L8.95778 12.0603L18.4005 2.61757Z'
        stroke='currentColor'
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
